import React from "react";
import "./BookingSection.css";
import CMS from "../cms.json";

const booking = CMS.booking || {};
const socials = CMS.socials || {};

const SOCIAL_ICONS = {
  tiktok:    { src: "https://img.icons8.com/?size=100&id=soupkpLfTkZi&format=png&color=FFFFFF", alt: "TikTok" },
  instagram: { src: "https://img.icons8.com/?size=100&id=85154&format=png&color=FFFFFF",        alt: "Instagram" },
  youtube:   { src: "https://img.icons8.com/?size=100&id=85064&format=png&color=FFFFFF",        alt: "YouTube" },
};

const BookingSection = () => {
  const email = booking.email || "booking@thecreaksofficial.com";

  return (
    <section id="booking" className="booking-section">
      <div className="booking-container">
        <h2 className="booking-title">{booking.title || "INTERESTED IN A COLLABORATION?"}</h2>
        <p className="booking-subline">{booking.subline || "For events, festivals, and professional inquiries, please get in touch."}</p>
        <div>
          <div className="booking-actions">
            <a href={`mailto:${email}`} className="cta-button primary">Contact Us</a>
            <a href="/presskit" target="_blank" rel="noopener noreferrer" className="cta-button secondary">View Press Kit</a>
          </div>
          <div className="booking-email">
            <p>Or directly at: <span className="email-address">{email}</span></p>
          </div>
        </div>

        <div className="socials-container">
          {Object.entries(SOCIAL_ICONS).map(([key, icon]) =>
            socials[key] ? (
              <a key={key} href={socials[key]} target="_blank" rel="noopener noreferrer" className="social-link">
                <img src={icon.src} alt={`The Creaks on ${icon.alt}`} className="social-icon" />
              </a>
            ) : null
          )}
        </div>
      </div>
    </section>
  );
};

export default BookingSection;
